module.exports = __webpack_public_path__ + "img/mid.66e5d122.png";